import { FC, useMemo } from 'react';
import { asLink } from '@prismicio/client';
import {
  JSXMapSerializer,
  PrismicLink,
  PrismicRichText,
} from '@prismicio/react';
import BannerStrip from '_components/BannerStrip';
import type { BannerStripData } from '@adapters/prismic/utils/mapBannerStripData';
import {
  trackBannerStripClick,
  type BannerStripInteractionLocation,
} from '_utils/GA4/trackBannerStripEvent';

const PrismicBannerStrip: FC<{
  data: BannerStripData;
  interactionLocation: BannerStripInteractionLocation;
}> = ({ data, interactionLocation }) => {
  const richTextComponents = useMemo<JSXMapSerializer>(
    () => ({
      paragraph: ({ children }) => <>{children}</>,
      hyperlink: ({ node, children, text }) => (
        <PrismicLink
          field={node.data}
          onClick={() =>
            trackBannerStripClick({
              data: {
                linkUrl: asLink(node.data) ?? '',
                linkText: text ?? '',
                interactionLocation,
              },
            })
          }
        >
          {children}
        </PrismicLink>
      ),
    }),
    [interactionLocation]
  );

  return (
    <BannerStrip
      iconName={data.iconName}
      title={
        data.title ? (
          <PrismicRichText field={data.title} components={richTextComponents} />
        ) : undefined
      }
      subtitle={
        data.subtitle ? (
          <PrismicRichText
            field={data.subtitle}
            components={richTextComponents}
          />
        ) : undefined
      }
      ctaText={data.cta?.text}
      ctaUrl={data.cta?.url}
      variant={data.variant}
      interactionLocation={interactionLocation}
    />
  );
};

export default PrismicBannerStrip;
